<template>
  <div class="internal-detail">
    <el-dialog
      title="对公转账审核"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="700px"
    >
      <template v-if="workLogDataOne.length && [40,60,80].includes(formInline.auditStatus)">
        <div class="title">
          <span class="title_inside" />
          驳回原因
        </div>
        <el-input
          type="textarea"
          :rows="6"
          readonly
          v-model="workLogData[workLogData.length - 1].auditNote"
          style="margin-bottom: 24px"
        />
      </template>
      <div class="title">
        <span class="title_inside" />
        对公转账信息
      </div>
      <div v-loading="loading" class="content">
        <el-form ref="formInline" :model="formInline" label-width="120px">
          <el-form-item label="班级名称:">
            {{ formInline.skuName }}
          </el-form-item>
          <el-form-item label="支付金额:">
            {{ formInline.payAmt }}
          </el-form-item>
          <el-form-item label="订单编号:">
            {{ formInline.orderNumber }}
          </el-form-item>
          <el-form-item label="转账人:">
            {{ formInline.remitterName }}
          </el-form-item>
          <el-form-item label="收款商户名称:">
            {{ formInline.gatheringName }}
          </el-form-item>
          <el-form-item label="收款账号:">
            {{ formInline.gatheringNumber }}
          </el-form-item>
          <el-form-item label="支付凭证:">
            <div class="flx">
              <div
                class="flx_inner"
                v-for="(item, index) in formInline.remitterVoucher"
                :key="index"
              >
                <el-image
                  style="width: 80px; height: 80px"
                  :src="item"
                  :preview-src-list="[item]"
                >
                </el-image>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-if="[2,40,60,80].includes(formInline.auditStatus)" label="审核状态:" prop="auditStatus">
            <span v-if="formInline.auditStatus === 2">通过</span>
            <span v-else>驳回</span>
          </el-form-item>
          <el-form-item
            v-if="formInline.auditStatus === 70"
            label="支付时间:"
            prop="payTimeStr"
          >
            {{ formInline.payTimeStr }}
          </el-form-item>
        </el-form>
      </div>

      <div class="title">
        <span class="title_inside" />
        审批流程
      </div>
      <template v-if="!workLogBool">
        <el-timeline  v-loading="loading">
          <el-timeline-item
            v-for="(activity, index) in workLogDataOne"
            :key="index"
            icon="el-icon-more"
            color="#4795f5"
            type="primary"
            size="large"
            :timestamp="activity.auditDate"
          >
            <div style="word-break: break-all">
              【{{ activity.companyName }}】
              <span style="margin-right: 16px">{{ activity.remarks }}<span v-if="![1,3,5].includes(activity.auditStatus)">, {{ activity.auditorName }}</span></span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <template v-else>
        <el-timeline  v-loading="loading">
          <el-timeline-item
            v-for="(activity, index) in workLogData"
            :key="index"
            :icon="index === 0 ? 'el-icon-more' : ''"
            :color="index === 0 ? '#4795f5' : ''"
            type="primary"
            size="large"
            :timestamp="activity.auditDate"
          >
            <div style="word-break: break-all">
              【{{ activity.companyName }}】
              <span style="margin-right: 16px">{{ activity.remarks }}<span v-if="![1,3,5].includes(activity.auditStatus)">, {{ activity.auditorName }}</span></span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <div
        v-if="workLogData.length > 1"
        class="show_box"
        @click="workLogBool = !workLogBool"
      >
        {{ workLogBool ? "收起" : "展开" }}
      </div>
      <span slot="footer" class="dialog-footer">
        <template v-if="[30,50,70].includes(formInline.auditStatus)">
          <el-button :loading="loading" type="primary" size="small" @click="handleClickAffirm">{{ identityLabel }}通过</el-button>
          <el-button :loading="loading" size="small" @click="toReject">{{ identityLabel }}驳回</el-button>
        </template>
        <el-button :loading="loading" size="small" @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 财务审核添加时间 -->
    <el-dialog
      title="财务复审"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogReAffirmVisible"
      :before-close="handleCloseReAffirm"
      width="540px"
    >
      <el-form
        ref="reAffirmRef"
        :model="reAffirmForm"
        :rules="rules"
        label-width="120px"
        size="small"
      >
        <el-form-item
          label="支付时间"
          prop="payTimeStr"
        >
          <el-date-picker
            v-model="reAffirmForm.payTimeStr"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            @change="payTimeStrChange"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseReAffirm">取 消</el-button>
        <el-button :loading="loading" type="primary" size="small" @click="handleConfirmReAffirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 驳回弹窗 -->
    <el-dialog
      :title="`${identityLabel}驳回`"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisibleReject"
      :before-close="handleCloseReject"
      width="540px"
    >
      <el-input
        type="textarea"
        v-model.trim="auditNote"
        :rows="4"
        :maxlength="300"
        show-word-limit
        placeholder="请输入驳回原因"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseReject">取 消</el-button>
        <el-button :loading="loading" type="primary" size="small" @click="handleConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAuditInfoByOrderId, getAuditLog, auditInternalOrder } from "@/api/orderAdmin/orderList";
import { getPrivateImgUrl } from '@/api/product/base'

export default {
  name: 'InternalTransferDetails',

  data () {
    return {
      dialogVisible: false,
      loading: false,
      orderId: null,
      formInline: {
        skuName: "",
        payAmt: "",
        orderNumber: "",
        remitterName: "",
        gatheringName: "",
        gatheringNumber: "",
        remitterVoucher: [],
        auditStatus: "",
        payTimeStr: ""
      },
      workLogData: [],
      workLogDataOne: [],
      workLogBool: false,
      dialogVisibleReject: false,
      auditNote: '',
      dialogReAffirmVisible: false,
      reAffirmForm: {
        payTimeStr: ''
      },
      rules: {
        payTimeStr: [
          { required: false, message: "请选择支付时间!", trigger: "change" },
        ]
      },
    }
  },
  computed: {
    identityLabel () {
      let t = ''
      switch (this.formInline.auditStatus) {
        case 30:
          t = '教务初审'
          break
        case 50:
          t = '财务复审'
          break
        case 70:
          t = '项目负责人复审'
          break
      }
      return t
    }
  },
  methods: {
    init (payload) {
      this.orderId = payload.id
      this.handleGetDetail(payload)
      this.dialogVisible = true
    },
    async handleGetDetail ({ id, skuName, payAmt }) {
      this.loading = true
      const { code, data } = await getAuditInfoByOrderId({ orderId: id })
      if (code !== 0) {
        this.$message.error('请求失败, 请重试!')
        return
      }
      this.formInline = {
        skuName: skuName || "--",
        payAmt: payAmt || "--",
        orderNumber: data?.orderNumber || "--",
        remitterName: data?.remitterName || "--",
        gatheringName: data?.gatheringName || "--",
        gatheringNumber: data?.gatheringNumber || "--",
        remitterVoucher: [],
        auditStatus: data?.auditStatus || "--",
        payTimeStr: data?.payTime || "--"
      };
      const list = data?.remitterVoucher?.split(",") || []
      list.filter(item => {
        getPrivateImgUrl(item).then(res => {
          this.formInline.remitterVoucher.push(res.data)
        })
      })
      // 获取审批记录
      const res = await getAuditLog({ orderId: id })
      if (res.code === 0 && res.data) {
        this.workLogData = res.data
        if (res.data.length > 0) {
          this.workLogDataOne = [res.data[0]]
        }
      }
      this.loading = false
    },
    // 点击审批通过
    handleClickAffirm () {
      if (this.formInline.auditStatus === 50) {
        this.dialogReAffirmVisible = true
      } else {
        this.handleAffirm()
      }
    },
    // 财务确认支付时间
    handleConfirmReAffirm () {
      this.$refs.reAffirmRef.validate(valid => {
        if (valid) {
          this.handleAffirm()
        }
      })
    },
    // 通过审批
    handleAffirm () {
      const labelText = `${this.identityLabel}通过`
      this.$confirm(`是否确认${labelText}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          auditStatus: 2,
          orderId: this.orderId,
          currentAuditStatus: this.formInline.auditStatus
        }
        if (this.formInline.auditStatus === 50) {
          params.payTimeStr = this.reAffirmForm.payTimeStr
        }
        this.loading = true
        auditInternalOrder(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success(`${labelText}成功!`)
            if (this.formInline.auditStatus === 70) {
              setTimeout(() => {
                this.handleRefresh()
              }, 1500)
            } else {
              this.handleRefresh()
              this.loading = false
            }
            this.handleCloseReAffirm()
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 1600)
        })
      })
    },
    // 点击驳回
    toReject () {
      this.dialogVisibleReject = true
    },
    // 确认驳回
    handleConfirm () {
      const params = {
        auditStatus: 3,
        orderId: this.orderId,
        auditNote: this.auditNote,
        currentAuditStatus: this.formInline.auditStatus
      }
      this.loading = true
      auditInternalOrder(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success(`${this.identityLabel}成功!`)
          if (this.formInline.auditStatus === 70) {
            setTimeout(() => {
              this.handleRefresh()
            }, 1500)
          } else {
            this.handleRefresh()
            this.loading = false
          }
          this.handleCloseReject()
        }
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 1600)
      })
    },
    handleRefresh () {
      this.handleGetDetail({
        id: this.orderId,
        ...this.formInline
      })
      this.$emit('refresh')
    },
    handleClose () {
      this.orderId = null
      this.formInline = this.$options.data().formInline
      this.workLogData = []
      this.workLogDataOne = []
      this.workLogBool = false
      this.dialogVisible = false
    },
    handleCloseReAffirm () {
      this.reAffirmForm.payTimeStr = ''
      this.$refs.reAffirmRef && this.$refs.reAffirmRef.resetFields()
      this.dialogReAffirmVisible = false
    },
    handleCloseReject () {
      this.auditNote = ''
      this.dialogVisibleReject = false
    },
    payTimeStrChange(payload) {
      this.reAffirmForm.payTimeStr = payload;
    }
  }
}
</script>

<style lang="scss" scoped>
.internal-detail {
  ::v-deep .el-dialog__body {
    padding: 16px 40px 30px 30px;
  }
  .title {
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 22px;
    margin-left: 2px;
    color: #333;
    .title_inside {
      display: inline-block;
      width: 4px;
      height: 18px;
      background: #4795f5;
      margin-right: 6px;
    }
  }
  .show_box {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    padding: 8px 0;
    font-size: 14px;
    margin-bottom: 30px;
    background-color: #ffffff;
  }
  .show_box:hover {
    background-color: #f9fafc;
  }
  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }
  ::v-deep .el-dialog__body {
    padding: 20px 20px 30px;
  }
  .flx {
    display: flex;
    flex-wrap: wrap;
    .flx_inner {
      margin: 0 6px;
    }
  }
}
.content {
  margin-bottom: 24px;
}
</style>
